module.exports = __webpack_public_path__ + "img/icon2.91076654.png";